module.exports = __webpack_public_path__ + "static/media/Step-3.00e8acb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/How it works/Step-3.jpg
// module id = 299
// module chunks = 0